import { render } from "./tableComponent.vue?vue&type=template&id=2ccc42b5&scoped=true"
import script from "./tableComponent.vue?vue&type=script&lang=js"
export * from "./tableComponent.vue?vue&type=script&lang=js"

import "./tableComponent.vue?vue&type=style&index=0&id=2ccc42b5&scoped=true&lang=css"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ccc42b5"]])

export default __exports__